export const heroData = {
  tag: "今日最热",
  headline: "吃瓜网51 — 全网黑料爆料第一阵地",
  slogan: "真相不缺席，黑料不迟到",
  description1: "吃瓜网51是国内领先的娱乐八卦与黑料爆料聚合平台，每日追踪娱乐圈、网红圈、商业圈最新动态。我们聚合全网最热爆料线索，为用户提供第一手内幕消息与深度分析，打造最真实、最及时的吃瓜体验。",
  description2: "无论你是资深吃瓜群众还是偶尔围观的过路网友，这里都有你想要的精彩内容。从明星塌房到网红翻车，从商业内幕到社会热点，吃瓜网51为你一网打尽。",
  stats: [
    { label: "日均更新", value: "50+条" },
    { label: "独家爆料", value: "1200+篇" },
    { label: "吃瓜群众", value: "80万+" },
  ],
  primaryCta: { text: "立即吃瓜", href: "#updates" },
  secondaryCta: { text: "我要爆料", href: "#contact" },
  heroImageUrl: "https://readdy.ai/api/search-image?query=A%20bold%20editorial%20illustration%20of%20a%20magnifying%20glass%20over%20newspaper%20clippings%20in%20warm%20red%20and%20amber%20tones%2C%20dramatic%20lighting%20on%20weathered%20paper%20texture%2C%20mysterious%20atmosphere%20with%20soft%20shadows%2C%20journalism%20investigation%20theme%2C%20high%20contrast%20editorial%20photography%20style%2C%20crimson%20gradient%20background%20with%20subtle%20grain%20texture&width=1200&height=900&seq=hero-main-2026&orientation=portrait",
};

export const updatesData = [
  { time: "10分钟前", title: "某顶流男星深夜密会被拍，神秘女子身份遭网友深扒", tag: "独家" },
  { time: "28分钟前", title: "知名主播带货翻车，直播间万人见证假货现场", tag: "热议" },
  { time: "1小时前", title: "综艺节目录制现场突发状况，嘉宾当场翻脸离场", tag: "最新" },
  { time: "2小时前", title: "某品牌代言人突然解约，背后内幕疑似与合同纠纷有关", tag: "追踪" },
  { time: "3小时前", title: "网红情侣疑似分手，社交平台互相取关引猜测", tag: "八卦" },
  { time: "4小时前", title: "某影视公司内部邮件曝光，涉及多位艺人片酬明细", tag: "内幕" },
  { time: "5小时前", title: "热门综艺导演被曝潜规则，当事人已发律师函回应", tag: "独家" },
  { time: "6小时前", title: "商圈大佬私下聚会照片流出，饭局内容引热议", tag: "热议" },
  { time: "8小时前", title: "某选秀节目选手背景造假，真实学历令人大跌眼镜", tag: "追踪" },
];

export const contactData = {
  title: "投稿爆料",
  subtitle: "你有料，我来曝",
  description: "如果你掌握独家内幕、拍到现场照片或掌握一手证据，欢迎通过以下方式联系我们。我们承诺严格保护爆料人隐私，绝不透露信息来源。真相需要被看见，你的线索可能成为明天的头条。",
  channels: [
    { icon: "ri-mail-line", label: "投稿邮箱", value: "tips@chigua51.com" },
    { icon: "ri-wechat-line", label: "微信爆料", value: "chigua51_tips" },
    { icon: "ri-smartphone-line", label: "爆料热线", value: "400-888-5151" },
  ],
};

export const cardsData = [
  {
    title: "某女星片场耍大牌，工作人员集体罢工抗议",
    excerpt: "据现场工作人员爆料，该女星在拍摄期间多次迟到，对剧组人员态度恶劣，最终导致全组停拍。制片方已紧急约谈其经纪团队。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20dimly%20lit%20film%20set%20with%20empty%20director%20chair%2C%20spotlight%20casting%20dramatic%20shadows%2C%20warm%20amber%20and%20crimson%20tones%2C%20tense%20atmosphere%2C%20editorial%20photography%20style%20with%20grainy%20texture&width=800&height=600&seq=card-01&orientation=landscape",
    tag: "片场风波",
    heat: "9.8万",
  },
  {
    title: "豪门联姻生变？上市公司千金被曝与男友分手",
    excerpt: "知情人士透露，这段被外界看好的恋情因双方家庭商业利益冲突而告终。男方家族企业股价今日开盘即下跌3%，引发市场关注。",
    imageUrl: "https://readdy.ai/api/search-image?query=Luxury%20skyscraper%20at%20dusk%20with%20warm%20golden%20window%20lights%2C%20corporate%20headquarters%20silhouette%20against%20evening%20sky%2C%20dramatic%20clouds%20in%20amber%20and%20deep%20red%20hues%2C%20wealth%20and%20power%20themed%20editorial%20photography&width=800&height=600&seq=card-02&orientation=landscape",
    tag: "豪门秘事",
    heat: "12.3万",
  },
  {
    title: "选秀导师私下收钱内定，选手录音曝光全过程",
    excerpt: "一段据称是某选秀节目导师与选手经纪人私下交易的录音在网络上疯传。节目组已发声明称将彻查此事，涉事导师暂未回应。",
    imageUrl: "https://readdy.ai/api/search-image?query=Recording%20studio%20microphone%20in%20dramatic%20lighting%2C%20warm%20red%20and%20amber%20spotlight%2C%20mysterious%20atmosphere%20with%20audio%20waveform%20visualization%2C%20investigative%20journalism%20style%2C%20high%20contrast%20shadows&width=800&height=600&seq=card-03&orientation=landscape",
    tag: "选秀黑幕",
    heat: "15.6万",
  },
  {
    title: "知名导演新片投资方撤资，牵连多位一线演员档期",
    excerpt: "该导演原定下月开机的新片因投资方临时撤资而搁浅。已签约的多位一线演员面临档期空转，损失或超千万。业内猜测与导演此前的负面新闻有关。",
    imageUrl: "https://readdy.ai/api/search-image?query=Empty%20movie%20theater%20with%20red%20velvet%20seats%2C%20single%20spotlight%20on%20empty%20stage%2C%20dramatic%20atmosphere%2C%20warm%20crimson%20and%20gold%20tones%2C%20vintage%20cinema%20aesthetic%20with%20grainy%20texture&width=800&height=600&seq=card-04&orientation=landscape",
    tag: "影视圈",
    heat: "8.2万",
  },
  {
    title: "网红带货产品质量翻车，消费者集体维权索赔",
    excerpt: "多位消费者反映在某头部网红直播间购买的美妆产品使用后出现过敏反应。第三方检测报告显示部分成分超标。目前已有超过500人加入维权群。",
    imageUrl: "https://readdy.ai/api/search-image?query=Beauty%20products%20scattered%20on%20a%20table%20under%20harsh%20lighting%2C%20magnifying%20glass%20examining%20cosmetics%2C%20warm%20amber%20and%20red%20alert%20tones%2C%20consumer%20protection%20theme%2C%20investigative%20photography%20style&width=800&height=600&seq=card-05&orientation=landscape",
    tag: "消费维权",
    heat: "11.1万",
  },
  {
    title: "偶像团体内部不和实锤，成员社交平台隔空互怼",
    excerpt: "该偶像团体两位核心成员近期在社交平台上的互动明显减少，更有粉丝发现两人互相取关后重新关注。知情人称矛盾源于资源分配不均。",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20spotlights%20facing%20away%20from%20each%20other%20on%20a%20dark%20stage%2C%20split%20lighting%20effect%2C%20dramatic%20warm%20crimson%20and%20amber%20contrast%2C%20entertainment%20industry%20tension%20theme%2C%20editorial%20photography&width=800&height=600&seq=card-06&orientation=landscape",
    tag: "饭圈风波",
    heat: "18.9万",
  },
];

export const faqData = [
  {
    question: "吃瓜网51的爆料信息可信度如何？",
    answer: "我们的每一条爆料都经过多源交叉验证后才发布。对于暂未完全核实的线索，我们会标注「待证实」标签，并持续追踪最新进展。我们建立了专业的爆料审核团队，确保信息的真实性和准确性，杜绝谣言传播。",
  },
  {
    question: "如何向吃瓜网51投稿爆料？",
    answer: "你可以通过网站底部的投稿邮箱、微信公众号或爆料热线联系我们。我们承诺严格保护爆料人隐私，采用匿名处理。提交线索时请尽量提供可以佐证的图片、视频或音频材料，便于我们快速核实。",
  },
  {
    question: "爆料信息发布后可以要求删除吗？",
    answer: "如涉及个人隐私或存在事实错误，当事人可通过官方邮箱提交删稿申请及相关证明材料。我们的法务团队会在收到申请后24小时内进行核实处理，确保各方权益得到公平对待。",
  },
  {
    question: "吃瓜网51的内容更新频率是怎样的？",
    answer: "我们实行7×24小时全天候更新机制。编辑团队三班制轮值，确保第一时间追踪热点事件。日均更新超过50条内容，重大事件发生后30分钟内即可发布首条快讯，让你永远走在吃瓜第一线。",
  },
  {
    question: "如何在手机上更方便地刷吃瓜内容？",
    answer: "你可以将吃瓜网51添加到手机浏览器书签，或通过微信公众号关注我们的推送。我们正在开发专属App，届时将提供更流畅的移动端阅读体验和实时推送通知功能，敬请期待。",
  },
  {
    question: "吃瓜网51的内容版权归谁所有？",
    answer: "本站所有原创内容版权归吃瓜网51所有。转载需注明出处并附带原文链接。我们鼓励合理分享，但对于未经授权的商业转载和篡改行为，我们将保留追究法律责任的权利。",
  },
];

export const commentsData = [
  {
    avatar: "https://readdy.ai/api/search-image?query=A%20minimal%20profile%20avatar%20circle%20with%20warm%20red%20gradient%20background%2C%20abstract%20geometric%20person%20silhouette%20in%20white%2C%20modern%20flat%20design%20style&width=120&height=120&seq=avatar-01&orientation=squarish",
    nickname: "资深吃瓜人",
    time: "3分钟前",
    content: "这个瓜保熟！我已经关注吃瓜网51半年了，爆的料准得离谱。上次那条民宿老板偷拍的料，第二天就被当事方承认了，服气！",
    likes: "2.3k",
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=A%20minimal%20profile%20avatar%20circle%20with%20amber%20gradient%20background%2C%20abstract%20geometric%20person%20silhouette%20in%20white%2C%20modern%20flat%20design%20style&width=120&height=120&seq=avatar-02&orientation=squarish",
    nickname: "朝阳区热心网友",
    time: "17分钟前",
    content: "刚把那篇选秀内幕的文章转发到朋友圈，十分钟不到就有三个朋友私信问我是不是知道啥。吃瓜网51是懂流量的，每篇标题都让人忍不住点进去看。",
    likes: "1.8k",
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=A%20minimal%20profile%20avatar%20circle%20with%20coral%20red%20gradient%20background%2C%20abstract%20geometric%20person%20silhouette%20in%20white%2C%20modern%20flat%20design%20style&width=120&height=120&seq=avatar-03&orientation=squarish",
    nickname: "不吃瓜会死星人",
    time: "42分钟前",
    content: "每天上班摸鱼就靠吃瓜网51续命了。你们那个最新快讯栏目我能连刷一小时，比刷短视频还上瘾。希望能多爆点商圈大佬的料，那个才刺激！",
    likes: "3.1k",
  },
];

export const carouselData = [
  {
    title: "2024娱乐圈塌房全记录：从顶流到素人",
    excerpt: "盘点这一年里跌下神坛的明星们，从税务问题到私德丑闻，每一个故事都比电视剧更精彩。全年累计12位艺人遭遇重大翻车事件。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20collage%20of%20shattered%20spotlight%20on%20a%20dark%20stage%2C%20fallen%20microphone%2C%20dramatic%20crimson%20and%20amber%20lighting%2C%20entertainment%20scandal%20theme%2C%20editorial%20photography%20with%20grainy%20texture%2C%20mysterious%20atmosphere&width=1000&height=700&seq=carousel-01&orientation=landscape",
    label: "年度盘点",
    updateTime: "7月28日更新",
  },
  {
    title: "网红经济大起底：流量背后的灰色产业链",
    excerpt: "深入调查网红带货、刷量、数据造假等乱象，揭开光鲜亮丽背后的隐秘操作。一条完整的灰色产业链正在悄然运转，涉及金额惊人。",
    imageUrl: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20social%20media%20metrics%20with%20cracked%20glass%20effect%2C%20dramatic%20red%20and%20amber%20lighting%2C%20dark%20background%2C%20digital%20deception%20theme%2C%20investigative%20journalism%20style%20photography&width=1000&height=700&seq=carousel-02&orientation=landscape",
    label: "深度调查",
    updateTime: "7月27日更新",
  },
  {
    title: "综艺节目剧本门：你以为的真实全是演的",
    excerpt: "多位综艺节目前工作人员匿名爆料节目制作内幕，从嘉宾人设到冲突设计，你所看到的每一个精彩瞬间背后都有精心编排的剧本。",
    imageUrl: "https://readdy.ai/api/search-image?query=TV%20studio%20control%20room%20with%20multiple%20monitors%2C%20script%20pages%20scattered%20on%20desk%2C%20dramatic%20red%20and%20amber%20lighting%2C%20behind%20the%20scenes%20television%20production%2C%20editorial%20photography%20with%20grainy%20texture&width=1000&height=700&seq=carousel-03&orientation=landscape",
    label: "独家揭秘",
    updateTime: "7月26日更新",
  },
  {
    title: "娱乐圈资本局：谁在幕后操控你的偶像",
    excerpt: "盘点娱乐圈背后的资本力量与利益格局。从对赌协议到股权置换，艺人不只是镁光灯下的表演者，更是资本棋盘上的关键棋子。",
    imageUrl: "https://readdy.ai/api/search-image?query=Stock%20market%20ticker%20overlaid%20on%20theater%20stage%20curtains%2C%20dramatic%20crimson%20and%20gold%20lighting%2C%20finance%20and%20entertainment%20intersection%20theme%2C%20editorial%20photography%20style%20with%20warm%20tones&width=1000&height=700&seq=carousel-04&orientation=landscape",
    label: "资本观察",
    updateTime: "7月25日更新",
  },
  {
    title: "偶像工业残酷真相：从练习生到流量的代价",
    excerpt: "独家探访国内偶像经纪公司内部运作，揭示练习生制度的残酷现实。光鲜的舞台背后是无数被透支的青春和被牺牲的个人生活。",
    imageUrl: "https://readdy.ai/api/search-image?query=Empty%20dance%20practice%20room%20with%20mirrors%2C%20single%20spotlight%2C%20dramatic%20shadows%2C%20warm%20amber%20and%20crimson%20tones%2C%20lonely%20atmosphere%2C%20K-pop%20training%20theme%20editorial%20photography&width=1000&height=700&seq=carousel-05&orientation=landscape",
    label: "行业揭秘",
    updateTime: "7月24日更新",
  },
  {
    title: "绯闻经济学：八卦如何成为一门数十亿的生意",
    excerpt: "从狗仔队到营销号，从热搜榜单到公关公司，一条完整的绯闻产业链正在疯狂吸金。每一个热搜背后，都有人在精准计算投入产出比。",
    imageUrl: "https://readdy.ai/api/search-image?query=Newspaper%20headlines%20with%20magnifying%20glass%2C%20dollar%20signs%20in%20red%20neon%2C%20dramatic%20amber%20lighting%2C%20gossip%20economy%20concept%2C%20editorial%20photography%20with%20warm%20crimson%20and%20gold%20tones&width=1000&height=700&seq=carousel-06&orientation=landscape",
    label: "财经视角",
    updateTime: "7月23日更新",
  },
];

export const featuresData = [
  {
    icon: "ri-flashlight-line",
    title: "最快爆料速度",
    description: "重大事件发生30分钟内发布首条快讯，三班制编辑团队全天候追踪热点，让你永远走在吃瓜第一线，不错过任何精彩瞬间。",
  },
  {
    icon: "ri-shield-check-line",
    title: "多源交叉验证",
    description: "每条爆料至少经过三个独立信源交叉验证，拒绝谣言、杜绝捏造。专业审核团队层层把关，只发布经得起推敲的真实信息。",
  },
  {
    icon: "ri-eye-off-line",
    title: "绝对隐私保护",
    description: "严格保护每一位爆料人的身份信息，采用多层加密和匿名处理机制。七年来从未发生过一起爆料人信息泄露事件，信誉有保障。",
  },
  {
    icon: "ri-fire-line",
    title: "独家深度分析",
    description: "不只是传递信息，更提供深度分析和背景解读。资深娱记和行业专家组成的分析团队，帮你读懂每一个八卦背后的深层逻辑。",
  },
  {
    icon: "ri-group-line",
    title: "百万吃瓜社区",
    description: "汇聚全国超80万吃瓜爱好者，在评论区一起讨论、分析和追踪最新爆料。这里不只有料，更有懂你的吃瓜同好。",
  },
];

export const aboutData = {
  title: "关于吃瓜网51",
  content1: "吃瓜网51成立于2018年，是国内领先的娱乐八卦聚合与黑料爆料平台。七年来，我们始终秉持「真实、快速、深度」的理念，为超过80万吃瓜爱好者提供每日最新、最热的娱乐资讯和内幕消息。",
  content2: "我们的编辑团队由前传统媒体记者、娱乐行业从业者和资深互联网运营组成，拥有丰富的行业资源和人脉网络。正是这些深耕行业多年的专业人才，让吃瓜网51能够在信息洪流中精准捕捉每一个值得关注的爆料线索。",
  content3: "从明星塌房到网红翻车，从选秀黑幕到资本暗战，吃瓜网51覆盖娱乐圈、网红圈、商业圈全领域八卦内容。我们不仅是信息的传递者，更是行业真相的挖掘者和记录者。每一个被曝光的黑料背后，都有我们团队日夜兼程的调查与核实。",
  stats: [
    { label: "创立于", value: "2018年" },
    { label: "累计爆料", value: "1200+篇" },
    { label: "活跃读者", value: "80万+" },
    { label: "日均更新", value: "50+条" },
  ],
};

export const topicsData = [
  { name: "明星塌房", heat: "98.6万", trend: "up", tag: "爆" },
  { name: "网红翻车", heat: "87.2万", trend: "up", tag: "热" },
  { name: "选秀内幕", heat: "73.5万", trend: "up", tag: "热" },
  { name: "综艺剧本", heat: "65.8万", trend: "stable", tag: "新" },
  { name: "商界秘闻", heat: "59.1万", trend: "up", tag: "" },
  { name: "饭圈动荡", heat: "52.4万", trend: "down", tag: "" },
  { name: "恋情曝光", heat: "48.7万", trend: "stable", tag: "" },
  { name: "合约纠纷", heat: "41.3万", trend: "up", tag: "" },
  { name: "片酬揭秘", heat: "36.9万", trend: "stable", tag: "" },
];

export const rankingData = [
  { rank: 1, title: "偶像团体内部不和实锤，成员隔空互怼升级", heat: "18.9万", change: "up" },
  { rank: 2, title: "选秀导师私下收钱内定，录音曝光全过程", heat: "15.6万", change: "up" },
  { rank: 3, title: "豪门联姻生变，上市公司千金分手内幕", heat: "12.3万", change: "up" },
  { rank: 4, title: "网红带货翻车，消费者集体维权索赔", heat: "11.1万", change: "stable" },
  { rank: 5, title: "某女星片场耍大牌，工作人员集体罢工", heat: "9.8万", change: "up" },
  { rank: 6, title: "知名导演新片投资方撤资牵连演员", heat: "8.2万", change: "down" },
  { rank: 7, title: "顶流男星深夜密会被拍，神秘女子身份曝光", heat: "7.5万", change: "up" },
];

export const indexData = [
  { title: "明星塌房全记录", count: 128, icon: "ri-alert-line" },
  { title: "网红翻车大合集", count: 96, icon: "ri-car-line" },
  { title: "选秀节目内幕", count: 73, icon: "ri-mic-line" },
  { title: "综艺翻车现场", count: 65, icon: "ri-tv-line" },
  { title: "商界大佬秘闻", count: 54, icon: "ri-briefcase-line" },
  { title: "恋情曝光专题", count: 82, icon: "ri-heart-line" },
  { title: "饭圈文化观察", count: 61, icon: "ri-chat-smile-2-line" },
  { title: "行业深度调查", count: 47, icon: "ri-search-eye-line" },
  { title: "娱乐法律案例", count: 35, icon: "ri-scales-line" },
];

export const mediaData = [
  {
    title: "独家对话：前娱记揭秘狗仔产业链运作内幕",
    duration: "45:22",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20journalist%20notebook%20and%20camera%20on%20a%20desk%2C%20warm%20red%20and%20amber%20lighting%2C%20investigative%20journalism%20atmosphere%2C%20play%20button%20overlay%2C%20editorial%20photography%20style%2C%20dramatic%20shadows&width=800&height=500&seq=media-01&orientation=landscape",
    views: "23.5万",
  },
  {
    title: "现场实拍：某综艺录制现场突发意外全程",
    duration: "12:08",
    imageUrl: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20television%20studio%20with%20cameras%20and%20crew%2C%20dramatic%20warm%20lighting%20in%20crimson%20and%20amber%2C%20chaotic%20production%20atmosphere%2C%20editorial%20photography%20style%2C%20play%20button%20overlay&width=800&height=500&seq=media-02&orientation=landscape",
    views: "18.7万",
  },
  {
    title: "深度分析：2024上半年塌房明星数据报告",
    duration: "28:15",
    imageUrl: "https://readdy.ai/api/search-image?query=Data%20charts%20and%20graphs%20on%20a%20dark%20background%20with%20dramatic%20red%20accent%20lighting%2C%20analytics%20dashboard%20theme%2C%20entertainment%20industry%20data%2C%20editorial%20photography%20style%2C%20play%20button%20overlay&width=800&height=500&seq=media-03&orientation=landscape",
    views: "31.2万",
  },
];

export const appData = {
  title: "随时随地，掌上吃瓜",
  subtitle: "扫码关注微信公众号，第一时间获取独家爆料推送",
  description: "微信搜索「吃瓜网51」或扫描二维码关注我们。独家爆料、突发事件、深度专题，所有精彩内容直达你的手机。App正在紧锣密鼓开发中，敬请期待更流畅的移动端吃瓜体验。",
  qrCodeUrl: "https://readdy.ai/api/search-image?query=A%20minimal%20QR%20code%20design%20on%20warm%20white%20background%20with%20crimson%20red%20accent%20corners%2C%20clean%20geometric%20pattern%2C%20modern%20flat%20design%2C%20no%20text%20on%20the%20QR%2C%20high%20contrast%20black%20and%20white&width=400&height=400&seq=qr-code&orientation=squarish",
  features: [
    "实时推送 · 爆料不错过",
    "独家内容 · 公众号专享",
    "评论互动 · 一起吃瓜讨论",
    "隐私保护 · 安全匿名投稿",
  ],
};